import { Config } from "../config/Config";
import { GetTextBlocksProps } from "../types/orc/PDFTypes";
import { ApiClient } from "./ApiClient";

export class ApiPDF {
    static basePath = Config.json.PDF_API_URL;

    static ConvertPdfToPng(pdf:FormData): Promise<string[]> {
        let path = '/convert_pdf_to_png';
        let url = this.basePath + path;

        return new Promise(async (resolve, reject) => {
        let response = await ApiClient.postFile(url, pdf);
        if (!response.ok) {
            if (response.status == 401) {
            reject('Unauthorized!');
            } else {
            reject(`Error! status: ${response.status}`);
            }
        }

        let responseObject =
            (await response.json()) as {images:string[]};

        resolve(responseObject.images);
        });
    };

    static ImageProcessing(image:FormData, grayscaling: boolean): Promise<string> {
        let path = '/image_processing_and_rotation';
        let url = this.basePath + path;

        image.append('grayscaling',grayscaling === true ? 'True' : 'False');
        
        return new Promise(async (resolve, reject) => {
        let response = await ApiClient.postFile(url, image);
        if (!response.ok) {
            if (response.status == 401) {
            reject('Unauthorized!');
            } else {
            reject(`Error! status: ${response.status}`);
            }
        }

        let responseObject =
            (await response.json()) as {'image': string};

        resolve(responseObject.image);
        });
    };

    static ExtractTextWithCoordinates(image:FormData, ocrConfig: string): Promise<GetTextBlocksProps[]> {
        let path = '/extract_text_with_coordinates';
        let url = this.basePath + path;

        image.append('customConfig',ocrConfig);
        
        return new Promise(async (resolve, reject) => {
        let response = await ApiClient.postFile(url, image);
        if (!response.ok) {
            if (response.status == 401) {
            reject('Unauthorized!');
            } else {
            reject(`Error! status: ${response.status}`);
            }
        }

        let responseObject =
            (await response.json()) as {textBlocks:GetTextBlocksProps[]};

        resolve(responseObject.textBlocks);
        });
    };

    static ExtractText(image:FormData): Promise<string> {
        let path = '/extract_text';
        let url = this.basePath + path;

        return new Promise(async (resolve, reject) => {
        let response = await ApiClient.postFile(url, image);
        if (!response.ok) {
            if (response.status == 401) {
            reject('Unauthorized!');
            } else {
            reject(`Error! status: ${response.status}`);
            }
        }

        let responseObject =
            (await response.json()) as {text:string};

        resolve(responseObject.text);
        });
    };
}